export type TicketStatus = 'OPEN' | 'INVESTIGATING' | 'WAITING' | 'RESOLVED' | 'CLOSED';
export type TicketPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

export interface TicketSignals {
  durationMs?: number;
  rageClicks?: number;
  deadClicks?: number;
  jsErrors?: number;
  frustrationScore?: number;
  replaySource?: string;
}

export interface TicketAssignee {
  id: string;
  name?: string;
  email: string;
}

export interface Ticket {
  id: string;
  number: number;
  title: string;
  description?: string;
  status: TicketStatus;
  priority: TicketPriority;
  customerName?: string;
  customerEmail?: string;
  customerOrg?: string;
  projectId?: string;
  sessionId?: string;
  assignee?: TicketAssignee;
  tags: string[];
  signals: TicketSignals;
  createdAt: string;
  updatedAt: string;
}

export interface TicketNote {
  id: string;
  body: string;
  author: TicketAssignee;
  createdAt: string;
}

export interface TicketDetail extends Ticket {
  notes: TicketNote[];
  /** Annotated tester-mode screenshot (data URL), when the ticket was filed via tester mode. */
  screenshotUrl?: string;
}

export const STATUS_COLOR: Record<TicketStatus, string> = {
  OPEN: '#f59e0b',
  INVESTIGATING: '#3b82f6',
  WAITING: '#8b5cf6',
  RESOLVED: '#2ec2b3',
  CLOSED: '#64748b',
};

export const PRIORITY_COLOR: Record<TicketPriority, string> = {
  LOW: '#64748b',
  MEDIUM: '#3b82f6',
  HIGH: '#f59e0b',
  CRITICAL: '#ef4444',
};

export const STATUS_OPTIONS: TicketStatus[] = ['OPEN', 'INVESTIGATING', 'WAITING', 'RESOLVED', 'CLOSED'];
export const PRIORITY_OPTIONS: TicketPriority[] = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];

export const cap = (s: string) => s.charAt(0) + s.slice(1).toLowerCase();
